import React from "react";

import ShorexIcon from "./ShorexIcon";
import { IconName } from "@silversea-ssc/ui-components-react";
import { useExcursionsMicroContent } from "features/shorex/ExcursionsMicroContentProvider";
import { ShorexCode } from "src/page-components/cruise/itinerary/types";

interface DefaultShorexIconProps {
  code: ShorexCode;
  showDescription?: boolean;
  showLabel?: boolean;
  showLabelMobile?: boolean;
  className?: string;
  iconClassName?: string;
  size: "small" | "big";
}

const DefaultShorexIcon: React.FC<
  React.PropsWithChildren<DefaultShorexIconProps>
> = ({ code, ...otherProps }) => {
  const { features = [] } = useExcursionsMicroContent();
  const { icon, label, content } = features.find((x) => x?.code == code) || {};

  return (
    <ShorexIcon
      {...otherProps}
      iconName={icon as IconName}
      label={label?.localized || ""}
      description={content?.localized || ""}
    />
  );
};

export default DefaultShorexIcon;
